<script lang="ts">
    import {kSeats} from "../rules";
    import type {Member} from "../firestore";
    import MemberComp from "./Member.svelte";

    export let assignments: { [K in kSeats]?: Member } = {};
    export let selected: typeof kSeats[number] | null = null;
    export let selectable: boolean = true;

    function trySelect(letter: string, ordinal: number) {
        if (selectable && assignments[`${letter}${ordinal}`] === undefined) {
            selected = `${letter}${ordinal}`;
        }
    }
</script>

<style lang="scss">
  @import 'svelte-materialify/src/styles/tools/colors';

  .seat-picker {
    --base-unit: max(1.2vw, 15px);

    margin: 0 auto;

    .table {
      width: calc(var(--base-unit) * 20);
      height: calc(var(--base-unit) * 8);
      position: relative;
      background-color: material-color('grey', 'lighten-1');
      border-radius: 0.4rem;
    }

    .seat {
      width: calc(var(--base-unit) * 10);
      height: calc(var(--base-unit) * 4);
      position: absolute;
      background-color: material-color('grey', 'lighten-2');
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid material-color('grey', 'darken-1');
      border-radius: 0.4rem;
      cursor: pointer;
      transition: all 0.1s ease;
      font-size: calc(var(--base-unit) * 0.8);
    }

    .seat:not([disabled]):hover {
      transform: scale(1.03, 1.03);
    }

    .seat:not([disabled]):active {
      transform: scale(0.96, 0.96);
      filter: brightness(90%);
    }

    .seat[disabled] {
      cursor: not-allowed;
    }

    .seat.selectable[disabled] {
      background-color: material-color('grey', 'lighten-1');
      filter: brightness(70%);
    }

    .seat.selected {
      background-color: material-color('blue-grey', 'lighten-2');
      border: 2px solid material-color('blue-grey', 'darken-1');
    }

    .seat.selected::before {
      content: '✓ Selected';
    }

    .ordinal-1 {
      top: 0;
      left: calc(var(--base-unit) * 5);
    }

    .ordinal-2 {
      top: calc(var(--base-unit) * 4);
      left: 0;
    }

    .ordinal-3 {
      top: calc(var(--base-unit) * 4);
      left: calc(var(--base-unit) * 10);
    }

    td {
      padding: calc(var(--base-unit) / 1.5);
    }
  }
</style>

<table class="seat-picker">
    {#each [['B', 'A'], ['C', 'D']] as letterSet}
        <tr>
            {#each letterSet as letter}
                <td>
                    <div class="table">
                        {#each [1, 2, 3] as ordinal}
                            <div class="seat ordinal-{ordinal} {letter + ordinal === selected ? 'selected' : ''} {selectable ? 'selectable' : ''}"
                                 disabled={(assignments[`${letter}${ordinal}`] !== undefined) || !selectable ? true : undefined}
                                 on:click={() => trySelect(letter, ordinal)}>
                                {#if assignments[`${letter}${ordinal}`] !== undefined}
                                    <MemberComp value={assignments[`${letter}${ordinal}`]}/>
                                {:else if selected !== letter + ordinal}
                                    <div class="text-body-1">{letter}{ordinal}</div>
                                {/if}
                            </div>
                        {/each}
                    </div>
                </td>
            {/each}
        </tr>
    {/each}
</table>